exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-305c6c57],h3[data-v-305c6c57]{color:#160148}.address[data-v-305c6c57],h2[data-v-305c6c57]{text-align:center;margin-bottom:10px}.terms[data-v-305c6c57]{display:flex;flex-direction:column;align-items:flex-start;flex-wrap:wrap}.terms h3[data-v-305c6c57]{font-weight:700;text-transform:uppercase;margin-top:15px}.terms p[data-v-305c6c57]{text-indent:15px;margin:10px 0}.terms .agb[data-v-305c6c57]{width:100%}.terms .agb img[data-v-305c6c57]{display:block;width:80%;margin:1em auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-305c6c57","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/agb.vue
// module id = pMWM
// module chunks = 21